import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import {
    isStatsFilter,
    isPriceFilter,
    isDimensionFilter,
    constructStatsRange,
} from '../SbSharedRefineMenu/sbSharedRefineMenuHelpers';
import { handleMinimumFractionDigits } from 'dibs-buyer-price';

// components
import { FormattedMessage, FormattedNumber } from 'react-intl';
import CloseIcon from 'dibs-vg/dist/react/close';

// styles
import styles from './SbRespAppliedFiltersItem.scss';

const rangeSeparator = <FormattedMessage id="sb.SbRespAppliedFilterItem.to" defaultMessage="to" />;

export const SbRespAppliedFiltersItem = props => {
    const {
        filterName,
        filterValue,
        onCloseClick,
        currency,
        availableValues,
        measurementUnit,
    } = props;
    const { displayName, urlLabel } = filterValue;

    let value = displayName;
    let dimension = null;

    if (isDimensionFilter(filterName)) {
        dimension = measurementUnit.toLowerCase();
    }

    if (isStatsFilter(filterName)) {
        const [min, max] = constructStatsRange(urlLabel, get(availableValues, '[0].urlLabel')).map(
            rangeValue => {
                if (isPriceFilter(filterName)) {
                    return (
                        <FormattedNumber
                            value={rangeValue}
                            style="currency"
                            currency={currency}
                            minimumFractionDigits={handleMinimumFractionDigits(rangeValue)}
                        />
                    );
                } else {
                    return rangeValue;
                }
            }
        );

        value = [min, ' ', rangeSeparator, ' ', max].map((comp, index) => (
            <React.Fragment key={index}>{comp}</React.Fragment>
        ));
    }

    return (
        <div className={styles.container} data-tn={`filter-${filterName}`}>
            <div>
                <span data-tn={`label-${filterName}`}>{`${filterName}:`}</span>
                <span className={styles.value} data-tn={`value-${filterName}`}>
                    {value} {dimension}
                </span>
            </div>
            <span
                data-tn="remove-filter"
                className={styles.closeIconWrapper}
                onClick={onCloseClick}
            >
                <CloseIcon />
            </span>
        </div>
    );
};

SbRespAppliedFiltersItem.propTypes = {
    currency: PropTypes.string,
    filterName: PropTypes.string.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    filterValue: PropTypes.object.isRequired,
    availableValues: PropTypes.array.isRequired,
    measurementUnit: PropTypes.string,
};
